module.exports = "<ngx-app-recette-list class=\"row\"></ngx-app-recette-list>\r\n"